import styles from "./ContactModal.module.scss";
import paymentImg from "../../assets/pictures/payment.png";
import { useTranslation } from "react-i18next";
import { LINKS } from "../../const";
import { trackClickContactUs } from "../../utils/analyticsTracker";

interface Props {
	onClose: () => void;
	avatarType: "2d" | "3d";
}

const ContactModal: React.FC<Props> = ({ onClose, avatarType }) => {
	const { t } = useTranslation('modals');

	const handleClick = () => {
		trackClickContactUs(avatarType);
		window.open(LINKS.telegram, "_blank");
		onClose();
	};

	return (
		<div className={styles.content}>
			<button className={styles.buttonClose} type="button" onClick={onClose} />
			<img src={paymentImg} alt="payment image" className={styles.linkImage} />
			<div className={styles.textContainer}>
				<h2>{t("assistant_ready")}</h2>
				<p>{t("assistant_cta")}</p>
			</div>
			<a className={styles.button} onClick={handleClick} aria-label="telegram" >{t("assistant_cta_btn")}</a>
		</div>
	);
};

export default ContactModal;
